import PropTypes from 'prop-types'
import Result from '@/components/shared/Result'
import resultStyles from '@/styles/templates/Listings/styles.module.css'
import composesStyles from '@/styles/_settings/composes.module.css'

const ResultStep = ({resultSetup}) => (
  <div
    className={`${composesStyles.paddingx} ${resultStyles.ecTemplateListings__result} ${composesStyles.animation_enterfrombottom} ${composesStyles.fullmaxwidth}`}
  >
    <Result {...resultSetup} />
  </div>
)

ResultStep.propTypes = {
  resultSetup: PropTypes.object.isRequired
}

export default ResultStep
